export default "__VITE_ASSET__CzBkIHBi__"